module.exports = __webpack_public_path__ + "img/advertising1.0eeca8da.png";